import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component } from '@angular/core';
import { Router } from '@angular/router';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { CmsService } from '@spartacus/core';
import { Subject, takeUntil } from 'rxjs';
import { CookieService } from 'src/app/customServices/cookie.service';
import { KbCheckOutService } from 'src/app/services/feature/CheckOut/kb-check-out.service';

@Component({
  selector: 'app-kb-checkoutparent',
  templateUrl: './kb-checkoutparent.component.html',
  styleUrls: ['./kb-checkoutparent.component.scss'],
  standalone: false
})
export class KbCheckoutparentComponent {
  isMobile: boolean;
  stepone: any;
  stepTwo: any;
  cartCode: any;
  stepthree: any;
  isgotData: boolean = false;
  orderSummary: any;
  totalAmt: any;
  subTotal: any;
  minOrderCharge: any;
  activeStep: any;
  canPlaceOrder: boolean = false;
  helpText: any;
  userInWhichStep: number = 0;
  private destroy$ = new Subject<void>();
  currentB2bUnitSendToWebtrack !: string;
  constructor(public breakpointObserver: BreakpointObserver,
    private checkoutService: KbCheckOutService,
    private activecart: ActiveCartFacade,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private cmsService: CmsService,
    private cookieService: CookieService
  ) {

    this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small])
      .pipe(takeUntil(this.destroy$)).subscribe(result => {
        this.isMobile = result.matches;
      });

  }
  ngOnInit() {
    this.userInWhichStep = this.cookieService.getItemSessionStorage('userInwhichStep') ?? 0;
    this.loadStep2Data();
    this.loadStep3Data();
    this.checkoutService.canOpen(true);
    this.activecart.getActive().pipe(takeUntil(this.destroy$)).subscribe((x: any) => {
      this.cartCode = x.code;
      this.currentB2bUnitSendToWebtrack = x.currentB2BUnit.uid;
      if (x) {
        this.checkoutService.checkoutStepOne(this.cartCode).pipe(takeUntil(this.destroy$)).subscribe((y: any) => {
          this.stepone = y;
          this.orderSummary = y.entries;
          this.isgotData = true;
          this.cdr.detectChanges();
        })
      }
    });

    this.checkoutService.finalOrderSummaryRight.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data) {
        this.orderSummary = data.entries;
        this.subTotal = data.subTotal;
        this.minOrderCharge = data.minOrderCharge;
        this.totalAmt = data.totalPrice;
        this.cdr.detectChanges();
      }
    })

    this.checkoutService.activeStep.pipe(takeUntil(this.destroy$)).subscribe(item => {
      this.activeStep = item;
    })

    this.cmsService
      .getComponentData('HelpParagraphComponent')
      .pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
        this.helpText = data;
      })
  }

  ngOnDestroy() {
    this.checkoutService.canOpen(false);
    this.destroy$.next();
    this.destroy$.complete();

  }

  loadStep3Data() {
    this.activecart.getActiveCartId().pipe(takeUntil(this.destroy$)).subscribe((cartId) => {
      if (cartId) {
        this.checkoutService.checkoutStepThree(cartId).pipe(takeUntil(this.destroy$)).subscribe(data => {
          this.stepthree = data;
        })
      }
    })
  }
  loadStep2Data() {
    this.activecart.getActiveCartId().pipe(takeUntil(this.destroy$)).subscribe((cartId) => {
      if (cartId) {
        this.checkoutService.checkoutStepTwo(cartId).pipe(takeUntil(this.destroy$)).subscribe(data => {
          this.stepTwo = data;
        })
      }
    })
  }

  placeOrderCheck(ev) {
    this.canPlaceOrder = ev.target.checked;
  }

  placeOrder() {
    this.activecart.getActiveCartId().pipe(takeUntil(this.destroy$)).subscribe((cartId) => {
      if (cartId) {
        this.checkoutService.placeOrder(cartId).pipe(takeUntil(this.destroy$)).subscribe(item => {
          console.log(item)
          if (item?.['status'] == 'SUCCESS') {
            this.router.navigate(['orderconfirmation'], {
              queryParams: { orderId: item?.['orderCode'] },
            });
          }
        })
      }
    })
  }
}
